import CustomDrawer from "../../../../shared/components/common/CustomDrawer";
import AppText from "../../../../shared/components/common/AppText";
import {GlobalStyleAttributes} from "../../../../shared/styles/GlobalStyles";
import {t} from "../../../../shared/services/i18n";
import {Radio, Tabs} from "antd";
import React, {useEffect, useMemo, useRef, useState} from "react";
import {HStack, VStack} from "native-base";
import FormInput from "../../../../shared/components/common/FormInput";
import AdvanceSelect from "../../../../shared/components/common/AdvanceSelect";
import {Datepicker, locale} from "@mobiscroll/react";
import {useSelector} from "react-redux";
import SharedTimepicker from "../../../../shared/components/common/SharedTimepicker";
import moment from "moment/moment";
import {dbDateFormat, isMobile} from "../../../../shared/services/Helpers";
import CustomCheckbox from "../../../../shared/components/common/CustomCheckbox";
import InfoTooltip from "../../../../shared/components/common/InfoTooltip";
import {fetchApi} from "../../../../shared/services/HTTP";
import {flowOptions} from "../../../../shared/components/Structure/Schedule/Popups/CreateEvent/FlowOptions";
import usePermissions from "../../../../shared/services/Permissions";
import {checkRequired} from "../../../../shared/services/stepperService";

const Export = (props) => {
    const {setFieldValue, values, touched, errors, validationSchema, validationObject} = props
    const [locationOptions, setLocationOptions] = useState([])
    const {has} = usePermissions()

    useEffect(() => {
        fetchLocationsByRivhitId()
    }, [])

    const fetchLocationsByRivhitId = async () => {
        const data = await fetchApi('locationsBox/getLocationByBoxId', 'post', {}, false, true);
        const grouped = _.groupBy(data, 'rivhitIdGroup');
        const result = _.map(grouped, (items) => ({
            label: _.map(items, 'location').join(', '),
            value: items[0].id
        }));
        setLocationOptions(result)
        if(result?.length === 1) {
            setFieldValue('location_fk', result[0].value ?? null)
        }
    }

    const onDateChange = (value) => {
        const date = moment(value)
        const month = date.month()
        const year = date.year()
        setFieldValue('month', month + 1)
        setFieldValue('year', year)
    }


    return (
        <VStack space={'1.5rem'}>
            {locationOptions?.length > 1 && <FormInput containerProps={{mb: 0}} label={t('location')+checkRequired('location_fk', validationObject)} width={'100%'}
                        error={(touched?.location_fk && errors?.location_fk) ? errors?.location_fk : null}>
                <AdvanceSelect dontSort options={locationOptions} initValue={values?.location_fk}
                               onChange={(option) => setFieldValue('location_fk', option.value ?? null)}
                               isError={touched?.location_fk && errors?.location_fk}/>
            </FormInput>}
            <FormInput containerProps={{ mb: 0 }} label={t('externalSite')} width={'100%'} error={(touched?.file_type && errors?.file_type) ? errors?.file_type : null}>
                <AdvanceSelect dontSort options={[{value: 2, label: t('rivhit-option')}, {value: 1, label: t('hashavshevet-option')}, {value: 4, label: t('hashavshevet-params-option')}]} 
                               initValue={values?.file_type} onChange={(option) => setFieldValue('file_type', option.value ?? null)} isError={touched?.file_type && errors?.file_type}/>
            </FormInput>
            <FormInput containerProps={{ mb: 0 }} label={t('date')} width={'100%'} error={(touched?.date && errors?.date) ? errors?.date : null}>
                <SharedTimepicker
                    type={'dates'}
                    dateFormat="MM/YYYY"
                    value={moment(`${values?.month} ${values.year}`, "MM/YYYY")}
                    max={moment()}
                    textStyle={{ fontSize: GlobalStyleAttributes.fonts.standard16 }}
                    onChange={onDateChange}
                    min={moment().subtract(10, 'years').startOf('year')}
                />
            </FormInput>
            {has('viewExportFileDatepicker') &&
                <FormInput containerProps={{ mb: 0 }} label={t('specificDate')} width={'100%'} error={(touched?.reference_date && errors?.reference_date) ? errors?.reference_date : null}>
                    <SharedTimepicker
                        type={'date'}
                        textStyle={{fontSize: GlobalStyleAttributes.fonts.standard16}}
                        value={values.reference_date}
                        onChange={(value) => setFieldValue('reference_date', moment(value).format(dbDateFormat))}
                        min={moment().subtract(10, 'years').startOf('year')}
                    />
                </FormInput>
            }

            <VStack space={'0.3'}>
                <AppText fontSize={GlobalStyleAttributes.fonts.infoText} mediumFont>{t('exportTo')}</AppText>
                <HStack>
                    <Radio.Group value={values.export_to} onChange={(e) => {
                        setFieldValue('export_to', e.target.value)
                        if(e.target.value === 'movFile') setFieldValue('email_to', null)
                    }}>
                        <HStack space={'1.2rem'}>
                            <Radio value={'movFile'} size="sm">
                                <AppText>{t('movFile')}</AppText>
                            </Radio>
                            <Radio value={'email'} size="sm">
                                <AppText>{t('email')}</AppText>
                            </Radio>
                        </HStack>
                    </Radio.Group>
                </HStack>
            </VStack>

            {values.export_to === 'email' &&
                <FormInput
                    label={t('email')}
                    value={values.email_to}
                    validationSchema={validationSchema}
                    name={'email'}
                    onChangeCallback={val => setFieldValue('email_to', val)}
                    error={(touched.email_to && errors.email_to) ? errors.email_to : null}
                    width={'100%'}
                    containerProps={{mb: '0rem'}}
                    type='email'
                />}

            {values.file_type === 1 &&
                <>
                    <FormInput
                        label={t('transactionType')}
                        validationSchema={validationSchema}
                        name={'general_sort'}
                        value={values.general_sort}
                        onChangeCallback={val => setFieldValue('general_sort', val)}
                        width={'100%'}
                        error={(touched.general_sort && errors.general_sort) ? errors.general_sort : null}
                        containerProps={{ mb: '0rem' }}
                    />
                    <FormInput
                        label={t('account')}
                        validationSchema={validationSchema}
                        name={'general_cust'}
                        value={values.general_cust}
                        onChangeCallback={val => setFieldValue('general_cust', val)}
                        width={'100%'}
                        error={(touched.general_cust && errors.general_cust) ? errors.general_cust : null}
                        containerProps={{ mb: '0rem' }}
                    />

                </>
            }

            <VStack space={'0.2rem'}>
                <AppText fontSize={GlobalStyleAttributes.fonts.infoText} mediumFont>{t('include')}</AppText>
                {values.file_type === 1 &&
                    <>
                        <CustomCheckbox isChecked={values.includeMtc} onChange={val => setFieldValue('includeMtc', val)} text={t('includeMtc')}/>
                        <CustomCheckbox isChecked={values.heshing} onChange={val => setFieldValue('heshing', val)} text={t('heshing')}/>
                    </>
                }
                <CustomCheckbox isChecked={values.new_transactions} onChange={val => setFieldValue('new_transactions', val)} text={t('newTransactions')}/>
                <CustomCheckbox isChecked={values.exclude_deposits} onChange={val => setFieldValue('exclude_deposits', val)} text={t('excludeDeposite')}/>
            </VStack>
        </VStack>


    )

}

export default Export